
import { ChipProps } from '@mui/material';

import _ from 'lodash';
import { DateTime } from 'luxon';

import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { ClientReportItem } from 'modules/components/layer19';
import React from 'react';
import * as ds from './dataService';


export type ClientReportDeliveryCardProps = {
  id: string;
  deliveries: {
    id: string;
    clientNotes: string;
    updatedAt: DateTime;
    dateReceived: DateTime | null;
    title: string;
    status: string;
    quantity: number;
    isIncluded: boolean;
    imageUrls: string[];
  }[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ClientReportDeliveryCardProps) => {

  const [fnUpdateIncludeItem] = ds.useSaveClientReportItem();

  return (
    <ActivityDetailSectionCardBaseLayout.FC
      title='Deliveries'
      subTitle='Deliveries that have been received after the last Client Report'
      actionButton={null}
      editActionButton={null}
    >
      {props.deliveries.map((node) => (
        <ClientReportItem.FC
          key={node.id}
          handleInclude={() => {
            fnUpdateIncludeItem({
              id: node.id, included: !node.isIncluded
            });
          }}
          clientNotes={node.clientNotes}
          reportItemType='DELIVERY'
          secondaryBox={{
            label: 'Arrived',
            value: node.dateReceived?.toFormat('DDDD') ?? ''
          }}
          included={node.isIncluded}
          status={{
            variant: node.status as ChipProps['variant'],
            label: _.upperFirst(_.snakeCase(node.status).replace('_', ' '))
          }}

          title={node.title}
          quantity={_.toString(node.quantity)}
          imageRow={{
            imgUrls: node.imageUrls
          }}
          id={node.id}
        />
      ))}


    </ActivityDetailSectionCardBaseLayout.FC>
  );
};


